export const BackgroundMedia = () => (
  <div className="w-full h-full bg-auth bg-no-repeat bg-cover absolute top-0 bottom-0 left-0 right-0 bg-zinc-900">
    <div className="w-full h-full absolute top-0 bottom-0 left-0 right-0 bg-linear-to-r from-black via-transparent to-black" />
    <video
      autoPlay
      loop
      muted
      className="w-full h-full object-cover"
      poster="/bg-frame.jpg"
    >
      <source
        src={import.meta.env.VITE_AUTH_BACKGROUND_VIDEO}
        type="video/mp4"
      />
    </video>
  </div>
);
